import { LoginFormData } from 'types/auth';

export const initialValues: LoginFormData = {
    email: '',
    password: '',
};
